module.exports = __webpack_public_path__ + "img/4-2.80191d0d.svg";